import _ from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import { createPortal } from 'react-dom';
import { isBrowser, makeDebugger, useEventCallback } from '../lib';
import usePortalElement from './usePortalElement';
var debug = makeDebugger('PortalInner');

/**
 * An inner component that allows you to render children outside their parent.
 */
var PortalInner = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var handleMount = useEventCallback(function () {
    return _.invoke(props, 'onMount', null, props);
  });
  var handleUnmount = useEventCallback(function () {
    return _.invoke(props, 'onUnmount', null, props);
  });
  var element = usePortalElement(props.children, ref);
  React.useEffect(function () {
    debug('componentDidMount()');
    handleMount();
    return function () {
      debug('componentWillUnmount()');
      handleUnmount();
    };
  }, []);
  if (!isBrowser()) {
    return null;
  }
  return /*#__PURE__*/createPortal(element, props.mountNode || document.body);
});
PortalInner.displayName = 'PortalInner';
PortalInner.propTypes = {
  /** Primary content. */
  children: PropTypes.node.isRequired,
  /** The node where the portal should mount. */
  mountNode: PropTypes.any,
  /**
   * Called when the portal is mounted on the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,
  /**
   * Called when the portal is unmounted from the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func
};
export default PortalInner;
//# sourceMappingURL=PortalInner.js.map